import React, { useContext } from 'react';
import { getLocalCache, setLocalCache } from '../common/AppUtils';
import { Helmet } from 'react-helmet';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { styled, ThemeProvider } from '@mui/material/styles';
import { Box } from '@mui/material';
import karyakramaTheme from './karyakramaTheme';
import { PRODUCT_NAME } from '../common/AppConstants';
import * as AppUrls from '../common/AppUrls';
import Copyright from './Copyright';
import TopBar from './TopBar';
import TestModeBanner from "./TestModeBanner";

const SIDE_NAV_OPEN_KEY = 'leftSideNavOpen';

const MainLayout = () => {
  const location = useLocation();
  const navigate = useNavigate();
  // Left Side Navigation
  const [open, setOpen] = React.useState(
    getLocalCache(SIDE_NAV_OPEN_KEY, true),
  );
  const toggleDrawer = () => {
    const newOpenState = !open;
    setOpen(newOpenState);
    setLocalCache(SIDE_NAV_OPEN_KEY, newOpenState);

    // If not on {DASHBOARD_URL_PREFIX}/* , navigate there
    if (!location.pathname.startsWith(AppUrls.DASHBOARD_URL_PREFIX)) {
      navigate(AppUrls.DASHBOARD_URL);
    }
  };

  // Define routes that need full width (for footer or other full-width components)
  const fullWidthRoutes = ['/', '/support'];
  const isFullWidth = fullWidthRoutes.includes(location.pathname);

  return (
    <ThemeProvider theme={karyakramaTheme}>
      <Helmet>
        <title>ClassChronicle | TimeTable Creator for Schools, Colleges & Universities</title>
      </Helmet>
      <Box
        className="main-layout"
        maxWidth={false}
        sx={{
          maxWidth: isFullWidth ? 'none' : `${karyakramaTheme.breakpoints.values.xxl}px`,
          margin: '0 auto',
      }}
      >
        <TestModeBanner />
        <TopBar toggleDrawer={toggleDrawer} menuOpen={open}/>
        <Box
          className="main-content"
          sx={{
            marginTop: '64px' ,
          }}
        >
          <Outlet
            context={{ toggleDrawer, open }}
          />
        </Box>
      </Box>
    </ThemeProvider>
  );
};

export default MainLayout;
